import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pageBack",
  style: {"padding-left":"10px","padding-right":"10px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "请输入您的问题")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("textarea", {
    maxlength: "200",
    class: "questionSizeContent",
    id: "myText",
    placeholder: "请输入您的问题"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "提问", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "deepseek回复")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      onClickLeft: _ctx.onClickLeft
    }, null, 8, ["onClickLeft"]),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", {
      class: "submit",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.question()))
    }, _hoisted_7),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content) = $event)),
        class: "answerSizeContent",
        id: "myAns",
        placeholder: "deepseek回复"
      }, null, 512), [
        [_vModelText, _ctx.content]
      ])
    ]),
    _hoisted_11
  ]))
}